/**
 * TanStack Query hooks for `cluster-analysis-group-level-anomaly`.
 * Thin wrappers over ./api. Query keys are centralized in api.ts.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	listGroups,
	clusterAnalysisGroupLevelAnomalyQueryKeys,
	type CreateClusterAnomalyBody,
	type CreateClusterAnomalyResponse,
	type ListClusterAnomalyResponse,
	type ListGroupRollupResponse,
} from "./api";

export function useClusterAnalysisGroupLevelAnomalyList(): UseQueryResult<
	ListClusterAnomalyResponse,
	Error
> {
	return useQuery({
		queryKey: clusterAnalysisGroupLevelAnomalyQueryKeys.list(),
		queryFn: list,
	});
}

export function useClusterAnalysisGroupLevelAnomalyGroups(): UseQueryResult<
	ListGroupRollupResponse,
	Error
> {
	return useQuery({
		queryKey: clusterAnalysisGroupLevelAnomalyQueryKeys.groups(),
		queryFn: listGroups,
	});
}

export function useClusterAnalysisGroupLevelAnomalyCreate(): UseMutationResult<
	CreateClusterAnomalyResponse,
	Error,
	CreateClusterAnomalyBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: clusterAnalysisGroupLevelAnomalyQueryKeys.all,
			});
		},
	});
}
